/* Godhund forside v4 – få og rolige bevegelser: innhold glir inn, og dagen går mot kveld.
   Ingen biblioteker. Alt innhold er synlig uten JavaScript og med «redusert bevegelse». Laget av Claude 23.09.2026. */
(function () {
  var root = document.querySelector('[data-g9]');
  if (!root) return;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  function play(v) { if (reduce) return; var p = v.play(); if (p && p.catch) p.catch(function () {}); }

  /* Menyen ligger over videoen på mobil: mål høyden, så toppen fyller skjermen */
  function measure() {
    var h = document.querySelector('.section-header');
    if (h) document.documentElement.style.setProperty('--g9-hh', h.offsetHeight + 'px');
    var hero = root.querySelector('[data-hero]');
    if (hero) {
      var top = hero.getBoundingClientRect().top + window.scrollY;
      root.style.setProperty('--g9-top', Math.max(0, Math.round(top)) + 'px');
    }
  }
  measure();
  addEventListener('load', measure);

  /* Toppvideo: stående fil på mobil, 4:5 på bredere skjermer. Bytter bare når bredden endrer seg
     (ikke når tastaturet eller adresselinjen endrer høyden). */
  var hv = root.querySelector('[data-hero-vid]');
  function kind() { return innerWidth >= 990 || innerWidth / Math.max(1, innerHeight) > 0.75 ? 'd' : 'm'; }
  /* HEVC først (mindre fil, skarpere bilde i Safari og nyere nettlesere), ellers H.264 */
  function setHero(k) {
    if (!hv || hv.getAttribute('data-k') === k) return;
    hv.setAttribute('data-k', k);
    hv.poster = hv.getAttribute('data-poster-' + k);
    hv.innerHTML = '<source src="' + hv.getAttribute('data-srch-' + k) + '" type=\'video/mp4; codecs="hvc1.1.6.L120.90"\'>' +
                   '<source src="' + hv.getAttribute('data-src-' + k) + '" type="video/mp4">';
    hv.muted = true;
    hv.load();
    play(hv);
  }
  if (hv) {
    if (reduce) { hv.removeAttribute('autoplay'); hv.pause(); }
    setHero(kind());
  }
  var lastW = innerWidth, rT;
  addEventListener('resize', function () {
    clearTimeout(rT);
    rT = setTimeout(function () {
      measure();
      if (innerWidth !== lastW) { lastW = innerWidth; setHero(kind()); }
    }, 150);
  });

  /* Videoer spiller bare når de er i bildet (sparer batteri og data) */
  var vio = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) {
        if (v.preload === 'none') v.preload = 'auto';
        play(v);
      } else if (!v.paused) v.pause();
    });
  }, { rootMargin: '200px 0px', threshold: 0.01 }) : null;
  root.querySelectorAll('[data-vid]').forEach(function (v) {
    v.muted = true;
    if (vio) vio.observe(v); else play(v);
  });
  if (hv && vio) vio.observe(hv);

  /* Utforsk: produktene går i bane rundt kategorinavnet (3D). Ekte produktbilder, ingen biblioteker.
     En vanlig seksjon: ringen snurrer rolig av seg selv, kan sveipes eller dras, og knappene over bytter kategori.
     Alt styres av tid, ikke av rulling, så siden ruller helt som vanlig. */
  var O = root.querySelector('[data-o]');
  if (O) orbit(O);
  function orbit(O) {
    var stage = O.querySelector('[data-o-stage]'), nav = O.querySelector('.g9-o__nav');
    if (!stage) return;
    [].slice.call(O.querySelectorAll('[data-o-cat]')).forEach(function (c) {        /* tomme kategorier vises ikke */
      if (!c.querySelector('.g9-o__card')) {
        var b = O.querySelector('[data-o-go="' + c.getAttribute('data-o-cat') + '"]');
        if (b) b.remove();
        c.remove();
      }
    });
    var cats = [].slice.call(O.querySelectorAll('[data-o-cat]'));
    var N = cats.length;
    if (!N) return;
    var tabs = [].slice.call(O.querySelectorAll('[data-o-go]'));
    var rings = cats.map(function (c) {
      var cards = [].slice.call(c.querySelectorAll('.g9-o__card'));
      return { el: c, title: c.querySelector('.g9-o__title'), cards: cards, n: cards.length, id: c.getAttribute('data-o-cat'), live: false,
               st: cards.map(function () { return { t: '', z: 0, o: -1, tap: null }; }) };
    });
    var label = O.querySelector('[data-o-label]'), lName = O.querySelector('[data-o-name]'), lPrice = O.querySelector('[data-o-price]');
    O.classList.add('g9-o--3d');
    [].forEach.call(O.querySelectorAll('.g9-o__card, .g9-o__card img'), function (el) { el.setAttribute('draggable', 'false'); });

    /* kategorinavnet reiser seg bokstav for bokstav (CSS gjør animasjonen) */
    rings.forEach(function (rg) {
      var h = rg.title && rg.title.querySelector('.g9-o__t'); if (!h) return;
      var txt = h.textContent.trim(), idx = 0;
      h.setAttribute('aria-label', txt);
      h.innerHTML = txt.split(/\s+/).map(function (w) {
        return '<span class="w" aria-hidden="true">' + Array.from(w).map(function (ch) {
          var e = document.createElement('span'); e.textContent = ch;
          return '<span class="l" style="--i:' + (idx++) + '">' + e.innerHTML + '</span>';
        }).join('') + '</span>';
      }).join(' ');
    });

    /* en tynn, stiplet banelinje (tegnes bare når størrelsen endres) */
    var NS = 'http://www.w3.org/2000/svg', svg = document.createElementNS(NS, 'svg'), path = document.createElementNS(NS, 'path');
    svg.setAttribute('class', 'g9-o__path'); svg.setAttribute('aria-hidden', 'true'); svg.appendChild(path);
    stage.insertBefore(svg, stage.firstChild);

    var IDLE = reduce ? 0 : 0.17, IN = reduce ? 1 : 820, OUT = reduce ? 1 : 520, GAP = reduce ? 0 : 200;
    var geo = null, cur = 0, prev = -1, tSwitch = 0, inStart = 0, introDone = reduce, rot = 0, vel = IDLE, rotTo = null;
    var pausedHover = false, pausedUntil = 0, drag = null, suppress = false, raf = 0, lastTs = 0, inView = false, started = false;
    var shown = null, labT = 0, titleT = 0, pathOn = false, mx = 0.5, mxs = 0.5;
    function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
    function eo(t) { return 1 - Math.pow(1 - t, 3); }
    function ei(t) { return t * t * t; }

    function measure() {
      var W = stage.clientWidth || innerWidth, mob = W < 750;
      var cw = mob ? clamp(W * 0.33, 108, 150) : clamp(W * 0.13, 150, 195);
      var R = mob ? clamp(W * 0.6, 196, 270) : Math.min(W * 0.34, 500);
      var tilt = (mob ? 36 : 20) * Math.PI / 180, f = mob ? 900 : 1700;
      var st = Math.sin(tilt), ct = Math.cos(tilt);
      var sF = f / (f - R * ct), sB = f / (f + R * ct);
      var up = R * st * sB + cw * sB / 2 + 12, down = R * st * sF + cw * sF / 2;
      var cy = (mob ? 6 : 14) + up;
      geo = { W: W, cw: cw, R: R, tilt: tilt, st: st, ct: ct, f: f, cy: cy };
      stage.style.setProperty('--osh', Math.round(cy + down + 70) + 'px');
      stage.style.setProperty('--ow', Math.round(cw) + 'px');
      stage.style.setProperty('--ocy', Math.round(cy) + 'px');
      stage.style.setProperty('--olab', Math.round(down + 12) + 'px');
      var d = '';
      for (var q = 0; q <= 72; q++) {
        var a = q / 72 * Math.PI * 2, s = f / (f - R * Math.cos(a) * ct);
        d += (q ? 'L' : 'M') + (W / 2 + R * Math.sin(a) * s).toFixed(1) + ' ' + (cy + R * Math.cos(a) * st * s).toFixed(1);
      }
      path.setAttribute('d', d);
      rings.forEach(function (rg) { rg.st.forEach(function (x) { x.t = ''; }); });
    }

    /* hvor ringen er i overgangen: inn fra dypet, eller ut forbi kameraet */
    function pose(j, now) {
      if (j === cur) {
        if (!inStart) return null;
        var t = clamp((now - inStart) / IN, 0, 1), e = eo(t);
        if (t >= 1 && !introDone) introDone = true;
        return { p: e, z: -1100 * (1 - e), r: 1 + 0.3 * (1 - e), tl: introDone ? 1 : 0.3 + 0.7 * e };
      }
      if (j === prev) {
        var t2 = clamp((now - tSwitch) / OUT, 0, 1), x = ei(t2);
        return { p: (1 - x) * (1 - x), z: 760 * x, r: 1 + 0.45 * x, tl: 1, done: t2 >= 1 };
      }
      return null;
    }

    function renderRing(rg, P) {
      var n = rg.n, R = geo.R * P.r, tl = geo.tilt * P.tl, st = Math.sin(tl), ct = Math.cos(tl), f = geo.f;
      var off = rot + (mxs - 0.5) * 0.6, best = null, bestCa = -2;
      for (var i = 0; i < n; i++) {
        var a = i * (Math.PI * 2 / n) - off, sa = Math.sin(a), ca = Math.cos(a);
        var Zd = R * ca * ct + P.z, den = f - Zd, S = rg.st[i], card = rg.cards[i], op = 0;
        if (den > f * 0.25) {
          var s = f / den;
          var depth = 0.4 + 0.6 * Math.pow((ca + 1) / 2, 0.85);                         /* kortene bak er blekere */
          var near = Zd > f * 0.3 ? clamp(1 - (Zd - f * 0.3) / (f * 0.35), 0, 1) : 1;    /* for nær kameraet: borte */
          op = P.p * depth * near;
          var tf = 'translate3d(' + (R * sa * s).toFixed(1) + 'px,' + (R * ca * st * s).toFixed(1) + 'px,0) perspective(900px) rotateY(' + (sa * 24).toFixed(1) + 'deg) scale(' + s.toFixed(3) + ')';
          if (tf !== S.t) { card.style.transform = tf; S.t = tf; }
          var zi = 1000 + Math.round(Zd);
          if (zi !== S.z) { card.style.zIndex = zi; S.z = zi; }
          if (ca > bestCa) { bestCa = ca; best = card; }
        }
        var ov = Math.round(op * 100) / 100;
        if (ov !== S.o) { card.style.opacity = ov; S.o = ov; }
        var tap = ov > 0.55 && ca > -0.2;
        if (tap !== S.tap) { card.classList.toggle('tap', tap); S.tap = tap; }
      }
      return { best: best, ca: bestCa };
    }

    function frame(now) {
      raf = 0;
      var dt = lastTs ? Math.min(0.05, (now - lastTs) / 1000) : 1 / 60;
      lastTs = now;
      if (rotTo !== null && !drag) {                                   /* tastatur: snurr kortet i fokus fram */
        rot += (rotTo - rot) * (1 - Math.exp(-dt * 7)); vel = 0;
        if (Math.abs(rotTo - rot) < 0.002) { rot = rotTo; rotTo = null; }
      } else if (!drag) {
        var target = pausedHover || now < pausedUntil ? 0 : IDLE;       /* rolig fart, eller mykt stopp når du holder eller peker */
        vel += (target - vel) * (1 - Math.exp(-dt * (Math.abs(vel) > IDLE * 2 ? 1.4 : 3.2)));
        rot += vel * dt;
      }
      mxs += (mx - mxs) * (1 - Math.exp(-dt * 3));
      var front = null;
      for (var j = 0; j < N; j++) {
        var rg = rings[j], P = pose(j, now), live = !!P && P.p > 0.002;
        if (live !== rg.live) { rg.el.classList.toggle('is-live', live); rg.live = live; }
        if (!P) continue;
        var r = renderRing(rg, P);
        if (j === cur && P.p > 0.6) front = r;
        if (j === prev && P.done) { prev = -1; rg.el.classList.remove('is-live'); rg.live = false; }
      }
      var settled = introDone && prev < 0 && inStart && now - inStart >= IN;
      if (settled !== pathOn) { svg.classList.toggle('on', settled); pathOn = settled; }
      var want = front && front.ca > 0.86 ? front.best : (front && shown && front.ca > 0.5 ? shown : null);
      if (want !== shown) {
        shown = want;
        clearTimeout(labT);
        label.classList.add('is-out');
        if (want) labT = setTimeout(function () {
          lName.textContent = want.getAttribute('data-name');
          lPrice.textContent = want.getAttribute('data-price');
          label.classList.remove('is-out');
        }, 170);
      }
      var moving = !reduce || drag || rotTo !== null || prev >= 0 || now - inStart < IN + 50;
      if (inView && !document.hidden && moving) raf = requestAnimationFrame(frame); else lastTs = 0;
    }
    function kick() { if (!raf && inView && !document.hidden) raf = requestAnimationFrame(frame); }

    function setTabs() {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-o-go') === rings[cur].id;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && nav && nav.scrollWidth > nav.clientWidth) nav.scrollTo({ left: t.offsetLeft - (nav.clientWidth - t.offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth' });
      });
    }
    function select(j) {
      if (j === cur || j < 0) return;
      if (!started) { cur = j; setTabs(); return; }
      var now = performance.now();
      if (prev >= 0) { rings[prev].el.classList.remove('is-live'); rings[prev].live = false; }
      prev = cur; cur = j; tSwitch = now; inStart = now + GAP;
      rings[prev].title.classList.remove('in');
      clearTimeout(titleT);
      titleT = setTimeout(function () { rings[cur].title.classList.add('in'); }, GAP + 100);
      [].forEach.call(rings[cur].el.querySelectorAll('img'), function (im) { im.loading = 'eager'; });
      pausedUntil = 0;
      setTabs();
      kick();
    }
    function begin() {
      started = true;
      inStart = performance.now();
      setTimeout(function () { rings[cur].title.classList.add('in'); }, reduce ? 0 : 160);
      kick();
      setTimeout(function () {                                         /* hent bildene til de andre kategoriene i forkant */
        [].forEach.call(O.querySelectorAll('.g9-o__card img'), function (im) { im.loading = 'eager'; });
      }, 1800);
    }

    /* knappene over ringen */
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(rings.map(function (r) { return r.id; }).indexOf(t.getAttribute('data-o-go'))); });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var nt = tabs[(i + d + tabs.length) % tabs.length];
        nt.focus(); nt.click();
      });
    });

    /* sveip og dra: bare sidelengs. Ruller du opp eller ned, ruller siden som vanlig */
    stage.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      drag = { x0: e.clientX, y0: e.clientY, r0: rot, lt: performance.now(), v: 0, moved: false, id: e.pointerId };
      pausedUntil = performance.now() + 60000;
      rotTo = null;
      kick();
    });
    stage.addEventListener('pointermove', function (e) {
      if (e.pointerType === 'mouse') { mx = e.clientX / innerWidth; }
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x0, dy = e.clientY - drag.y0;
      if (!drag.moved) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        if (Math.abs(dy) > Math.abs(dx)) { drag = null; pausedUntil = performance.now() + 700; return; }
        drag.moved = true;
        stage.classList.add('is-drag');
        try { stage.setPointerCapture(e.pointerId); } catch (err) {}
      }
      var now = performance.now(), nr = drag.r0 - dx / (geo.R * 1.1), dt = Math.max(8, now - drag.lt);
      drag.v = drag.v * 0.55 + ((nr - rot) / dt * 1000) * 0.45;
      drag.lt = now; rot = nr; vel = 0;
      kick();
    });
    var endDrag = function (e) {
      if (!drag || (e && e.pointerId !== drag.id)) return;
      var d = drag; drag = null;
      stage.classList.remove('is-drag');
      if (d.moved) {
        vel = clamp(d.v, -5, 5);
        pausedUntil = 0;
        suppress = true; setTimeout(function () { suppress = false; }, 90);
      } else pausedUntil = performance.now() + 1500;
      kick();
    };
    stage.addEventListener('pointerup', endDrag);
    stage.addEventListener('pointercancel', function (e) {
      if (drag && e.pointerId === drag.id) { drag = null; stage.classList.remove('is-drag'); pausedUntil = performance.now() + 700; kick(); }
    });
    stage.addEventListener('click', function (e) { if (suppress) { e.preventDefault(); e.stopPropagation(); } }, true);
    stage.addEventListener('mouseenter', function () { pausedHover = true; });
    stage.addEventListener('mouseleave', function () { pausedHover = false; mx = 0.5; kick(); });
    stage.addEventListener('dragstart', function (e) { e.preventDefault(); });
    /* tastatur: et kort som får fokus, snurres fram */
    stage.addEventListener('focusin', function (e) {
      var c = e.target.closest ? e.target.closest('.g9-o__card') : null, rg = rings[cur], i = rg.cards.indexOf(c);
      if (i < 0) return;
      var base = i * (Math.PI * 2 / rg.n), k = Math.round((rot - base) / (Math.PI * 2));
      rotTo = base + k * Math.PI * 2 - (mxs - 0.5) * 0.6;
      pausedUntil = performance.now() + 5000;
      kick();
    });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) { lastTs = 0; kick(); } });

    var rT3;
    addEventListener('resize', function () { clearTimeout(rT3); rT3 = setTimeout(function () { measure(); kick(); if (!raf) frame(performance.now()); }, 150); });
    measure();
    setTabs();
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          inView = e.isIntersecting;
          if (inView && !started && e.intersectionRatio > 0.2) begin();
          if (inView) { lastTs = 0; kick(); }
        });
      }, { threshold: [0, 0.25] }).observe(stage);
    } else { inView = true; begin(); }
  }

  /* Bevegelse av: vis alt med en gang */
  if (reduce || !('IntersectionObserver' in window)) return;
  root.classList.add('js');

  /* Innhold glir rolig inn når det kommer i bildet */
  var items = [].slice.call(root.querySelectorAll('[data-rv]'));
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.04 });
  items.forEach(function (el) { io.observe(el); });
  /* Sikkerhetsnett: det som allerede er i eller over bildet, vises uansett */
  function safety() {
    var vh = innerHeight;
    items.forEach(function (el) { if (!el.classList.contains('in') && el.getBoundingClientRect().top < vh) el.classList.add('in'); });
  }
  setTimeout(safety, 2500);
  addEventListener('load', function () { setTimeout(safety, 300); });

  /* Dagen går mot kveld: historien går fra lys til natt før siste kapittel */
  var story = root.querySelector('[data-story]');
  var night = root.querySelector('[data-night]');
  if (story && night) {
    var C = {
      bg: [250, 245, 238], nbg: [42, 22, 8],
      fg: [34, 22, 15], nfg: [255, 248, 240],
      fg2: [107, 88, 71], nfg2: [214, 194, 172],
      line: [232, 219, 201], nline: [82, 58, 40],
      amb: [138, 60, 23], namb: [232, 160, 74]
    };
    var mix = function (a, b, t) {
      return 'rgb(' + Math.round(a[0] + (b[0] - a[0]) * t) + ',' + Math.round(a[1] + (b[1] - a[1]) * t) + ',' + Math.round(a[2] + (b[2] - a[2]) * t) + ')';
    };
    var last = -1, tick = false;
    var paint = function () {
      tick = false;
      var vh = innerHeight;
      var r = night.getBoundingClientRect();
      var start = vh * 0.95, end = vh * 0.3;
      var t = Math.max(0, Math.min(1, (start - r.top) / (start - end)));
      t = Math.pow(t, 2.2);
      if (Math.abs(t - last) < 0.004) return;
      last = t;
      story.style.setProperty('--sbg', mix(C.bg, C.nbg, t));
      story.style.setProperty('--sfg', mix(C.fg, C.nfg, t));
      story.style.setProperty('--sfg2', mix(C.fg2, C.nfg2, t));
      story.style.setProperty('--sline', mix(C.line, C.nline, t));
      story.style.setProperty('--samber', mix(C.amb, C.namb, t));
    };
    var onScroll = function () { if (!tick) { tick = true; requestAnimationFrame(paint); } };
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onScroll);
    paint();
  }
})();
